import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";

export class NoScoresClickEvent extends ClickEvent {
  entityId: String;
  entityType: String;
  sportTypeId: Number;
  filter: String;

  constructor(params: NoScoresClickEvent) {
    super('', 'click', 'no-scores');

    this.entityId = params.entityId;
    this.entityType = params.entityType;
    this.sportTypeId = params.sportTypeId;
    this.filter = params.filter;
  }

  get properties() {
    const properties = super.properties;

    properties.entityId = this.entityId;
    properties.entityType = this.entityType;
    properties.sportTypeId = this.sportTypeId;
    properties.filter = this.filter;

    return properties;
  }
}